const imagesPath = '../../images/';
const iconsPath = '../../icons/';

export class Assets {
  static liquid: string = `${imagesPath}liquid.png`;
  static chevronDown: string = `${iconsPath}chevron_down.svg`;
  static chat: string = `${iconsPath}chat.svg`;
  static chatWhite: string = `${iconsPath}chat_white.svg`;
  static chats: string = `${iconsPath}chats.svg`;
  static home: string = `${iconsPath}home.svg`;
  static points: string = `${iconsPath}points.svg`;
  static settings: string = `${iconsPath}settings.svg`;
  static appointments: string = `${iconsPath}appointments.svg`;
  static patientSearch: string = `${iconsPath}patient_search.svg`;
  static medecines: string = `${iconsPath}medecines.svg`;
  static notes: string = `${iconsPath}notes.svg`;
  static arrowRightTop: string = `${iconsPath}arrow_right_top.svg`;
  static logos: string = `${iconsPath}logos.svg`;
  static pointsWhite: string = `${iconsPath}points_white.svg`;
  static search: string = `${iconsPath}search.svg`;
  static comparison: string = `${iconsPath}comparison.svg`;
  static protocols: string = `${iconsPath}protocols.svg`;
  static translation: string = `${iconsPath}translation.svg`;
  static liquidGif: string = `${iconsPath}liquid_gif.gif`;
  static editWhite: string = `${iconsPath}edit_white.svg`;
  static select: string = `${iconsPath}select.svg`;
  static close: string = `${iconsPath}close.svg`;
  static noImage: string = `${iconsPath}no_image.svg`;
  static empty: string = `${iconsPath}empty.svg`;
  static stop: string = `${iconsPath}stop.svg`;
  static microphone: string = `${iconsPath}microphone.svg`;
  static microphoneBlue: string = `${iconsPath}microphone_blue.svg`;
  static microphoneGray: string = `${iconsPath}microphone_gray.svg`;
  static pause: string = `${iconsPath}pause.svg`;
  static play: string = `${iconsPath}play.svg`;
  static info: string = `${iconsPath}info.svg`;
  static compareMedicine: string = `${iconsPath}compare_medicine.svg`;
  static fichaTecnica: string = `${iconsPath}ficha_tecnica.svg`;
  static prospecto: string = `${iconsPath}prospecto.svg`;
  static trash: string = `${iconsPath}trash.svg`;
  static trashRed: string = `${iconsPath}trash_red.svg`;
  static menu: string = `${iconsPath}menu.svg`;
  static menuDots: string = `${iconsPath}menu_dots.svg`;
  static createNew: string = `${iconsPath}create_new.svg`;
  static image: string = `${iconsPath}image.svg`;
  static differentialDiagnostic: string = `${iconsPath}differential_diagnostic.svg`;
  static calculators: string = `${iconsPath}calculators.svg`;
  static information: string = `${iconsPath}information.svg`;
  static laboratory: string = `${iconsPath}laboratory.svg`;
  static paperclip: string = `${iconsPath}paperclip.svg`;
  static smallMicrophone: string = `${iconsPath}small_microphone.svg`;
  static send: string = `${iconsPath}send.svg`;
  static plus: string = `${iconsPath}plus.svg`;
  static infoRed: string = `${iconsPath}info_red.svg`;
  static infoGold: string = `${iconsPath}info_gold.svg`;
  static infoGreen: string = `${iconsPath}info_green.svg`;
  static share: string = `${iconsPath}share.svg`;
  static expand: string = `${iconsPath}expand.svg`;
  static cancel: string = `${iconsPath}cancel.svg`;
  static mute: string = `${iconsPath}mute.svg`;
  static unmute: string = `${iconsPath}unmute.svg`;
  static email: string = `${iconsPath}email.svg`;
  static showButtons: string = `${iconsPath}show_buttons.svg`;
  static unshowButtons: string = `${iconsPath}unshow_buttons.svg`;
  static bigInformation: string = `${iconsPath}big_information.svg`;
  static check: string = `${iconsPath}check.svg`;
  static checkWithoutCircle: string = `${iconsPath}check_without_circle.svg`;
  static swapHorizontal: string = `${iconsPath}swap_horizontal.svg`;
  static copy: string = `${iconsPath}copy.svg`;
  static unmuteGray: string = `${iconsPath}unmute_gray.svg`;
}